export default __webpack_public_path__ + "static/open-graph-0ff22796e5dc0d6278ce92502cd1842b.png";